import { render, staticRenderFns } from "./ButtonListV2.vue?vue&type=template&id=4d441bf1&scoped=true&"
import script from "./ButtonListV2.vue?vue&type=script&lang=ts&"
export * from "./ButtonListV2.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonListV2.vue?vue&type=style&index=0&id=4d441bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d441bf1",
  null
  
)

export default component.exports